import api from 'plugin/api';
import { API_URL } from 'types/const';

/**
 * 로그인
 * @param {Object} data 요청 데이터
 * @param {string} data.userId 아이디
 * @param {string} data.userPwd 비밀번호
 * @return {Object} 응답 데이터
 */
async function requestLogin(data) {
  return api.post(API_URL.login.default, data);
}

/**
 * 토큰 유효성 확인
 * @return {Object} 응답 데이터
 */
async function requestValid() {
  return api.post(API_URL.login.valid);
}

export { requestLogin, requestValid };
